/**
 * Сквозная аналитика Bitrix24 (call.tracker.js → b24Tracker.guest.getTrace).
 * @see https://apidocs.bitrix24.ru/tutorials/crm/how-to-use-analitycs/use-analitics-for-add-contact.html
 */

/** Дефолт с портала Idealitika (b7654435). Dev/prod можно развести через env. */
export const DEFAULT_BITRIX24_CALL_TRACKER_SRC =
  "https://cdn-ru.bitrix24.ru/b7654435/crm/tag/call.tracker.js";

/**
 * URL скрипта call.tracker.js.
 * Приоритет: NEXT_PUBLIC_BITRIX24_CALL_TRACKER_URL →
 * NEXT_PUBLIC_BITRIX24_CALL_TRACKER_URL_DEV|PROD по APP_ENV → дефолт.
 */
export function getBitrix24CallTrackerSrc(): string {
  const shared = process.env.NEXT_PUBLIC_BITRIX24_CALL_TRACKER_URL?.trim();
  if (shared) return shared;

  const appEnv = (
    process.env.APP_ENV ||
    process.env.NEXT_PUBLIC_APP_ENV ||
    process.env.NODE_ENV ||
    ""
  ).toLowerCase();
  const isProd = appEnv === "production" || appEnv === "prod";
  const byEnv = isProd
    ? process.env.NEXT_PUBLIC_BITRIX24_CALL_TRACKER_URL_PROD?.trim()
    : process.env.NEXT_PUBLIC_BITRIX24_CALL_TRACKER_URL_DEV?.trim();
  if (byEnv) return byEnv;

  return DEFAULT_BITRIX24_CALL_TRACKER_SRC;
}

type B24GuestTracker = {
  getTrace?: (arg?: unknown) => unknown;
  /** Снимок трейса без очистки (в отличие от getTrace). */
  remindTrace?: (arg?: unknown) => unknown;
  getPages?: () => unknown;
  getUtmSource?: () => unknown;
};

declare global {
  interface Window {
    b24Tracker?: { guest?: B24GuestTracker };
  }
}

function asTraceString(raw: unknown): string | undefined {
  if (typeof raw !== "string") return undefined;
  const trimmed = raw.trim();
  return trimmed && trimmed !== "{}" && trimmed !== "null" ? trimmed : undefined;
}

/**
 * Снимок сквозной аналитики без очистки.
 * getTrace() после чтения стирает путь — на переходах страниц его нельзя звать.
 */
export function peekBitrix24GuestTrace(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const guest = window.b24Tracker?.guest;
  if (!guest || typeof guest.remindTrace !== "function") return undefined;
  try {
    return asTraceString(guest.remindTrace());
  } catch {
    return undefined;
  }
}

/**
 * Трейс посетителя для crm.tracking.trace.add.
 * Вызывать один раз прямо перед отправкой формы / OAuth (чтение очищает трейс).
 * Если скрипт не загрузился — undefined (форму не блокируем).
 */
export function readBitrix24GuestTrace(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const guest = window.b24Tracker?.guest;
  if (!guest || typeof guest.getTrace !== "function") return undefined;
  try {
    return asTraceString(guest.getTrace());
  } catch {
    return undefined;
  }
}
